var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNmb7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 584.71 627.06",
    style: {
      enableBackground: "new 0 0 584.71 627.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE2624;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,201.55c48.42-87.06,141.36-146.1,247.83-146.1c156.25,0,283.39,127.13,283.39,283.4 c0,156.25-127.14,283.38-283.39,283.38c-23.55,0-46.32-3.21-68.22-8.65l205.66-381.6v-43.17h-234.1v53.25h145.36 c17.27,0,13.91,10.07,2.87,31.18L125.82,594.23C72.65,568.72,28.58,527.18,0,475.89v86.87c22.81,25.23,49.42,46.96,78.91,64.3 h337.85c98.79-58.12,165.25-165.54,165.25-288.21c0-184.27-149.92-334.18-334.18-334.18C149.63,4.67,61.19,47.26,0,114.93V201.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmb7);
export default __webpack_public_path__ + "static/media/nmb_7.794b9c834877c3cb09e085179dcc0fed.svg";
export { ForwardRef as ReactComponent };